module.exports = __webpack_public_path__ + "img/清河头乡.12314c0e.png";